import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import BusinessBasicInfoComponent from './business-basic-info.component';
import AddBusinessComponent from './add-business';
import TenantDetailsComponent from './tenant-basic-info.component';


export const BusinessComponent = ({id,handleInnerFormChange,selectedBusiness,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<BusinessBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        businessDetails={selectedBusiness}
        />,
    isVisible:id> 0 ? true: false,
    },
    {
      id:2,
      title:'Tenant Information',
      component:<TenantDetailsComponent 
      businessDetails={selectedBusiness}
      />,
  isVisible:id> 0 ? true: false,
  },
    {
      id:3,
      title:'Business Registration Information',
      component:<AddBusinessComponent 
      handleInnerFormChange={handleInnerFormChange}
      businessDetails={selectedBusiness}
      />,
    isVisible:id== 0 ? true: false,
  },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             {id == 0 &&
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>}
        </div>
       </div>
  )
}
export default BusinessComponent;
